exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  z-index: 100; }\n\nh5 {\n  color: #000;\n  font-size: 20px;\n  margin-top: -5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/precios/precio-dialog.component.scss
// module id = ../../../../../src/app/components/precios-seccion/precios/precio-dialog.component.scss
// module chunks = 0